import React, { useEffect, useState } from 'react';

export function useMobileScreen({ defaultInnerWidth = 1024 }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < defaultInnerWidth);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < defaultInnerWidth) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return {
        isMobile
    };
}
